import '../../assets/index42.css';var Be = Object.defineProperty, Le = Object.defineProperties;
var He = Object.getOwnPropertyDescriptors;
var q = Object.getOwnPropertySymbols;
var he = Object.prototype.hasOwnProperty, _e = Object.prototype.propertyIsEnumerable;
var ue = (t, r, l) => r in t ? Be(t, r, { enumerable: !0, configurable: !0, writable: !0, value: l }) : t[r] = l, _ = (t, r) => {
  for (var l in r || (r = {}))
    he.call(r, l) && ue(t, l, r[l]);
  if (q)
    for (var l of q(r))
      _e.call(r, l) && ue(t, l, r[l]);
  return t;
}, $ = (t, r) => Le(t, He(r));
var B = (t, r) => {
  var l = {};
  for (var i in t)
    he.call(t, i) && r.indexOf(i) < 0 && (l[i] = t[i]);
  if (t != null && q)
    for (var i of q(t))
      r.indexOf(i) < 0 && _e.call(t, i) && (l[i] = t[i]);
  return l;
};
import { jsx as a, jsxs as C, Fragment as Xe } from "react/jsx-runtime";
import { Pagination as je } from "../Pagination/index.js";
import { useState as A, useRef as be, useEffect as Ee, useLayoutEffect as Me, useMemo as Ve } from "react";
import { Button as Z } from "../Button/index.js";
import { TextField as We } from "../TextField/index.js";
import { Menu as Q } from "../Menu/index.js";
import { T as fe } from "../../index-DvHxdYmP.js";
import { Checkbox as pe } from "../Checkbox/index.js";
import { ArrowDownFarFAIcon as Je, ArrowUpFarFAIcon as Ge, FilterFarFAIcon as qe, XMarkFarFAIcon as Ue } from "../Icons/index.js";
import { S as Te } from "../../Stack-Bh9dsrlC.js";
import { r as ve } from "../../rem-CMQJ_ZTp.js";
import { b as ye } from "../../get-size-BzhHC8s2.js";
import { c as ge } from "../../create-vars-resolver-Bzbn9G-G.js";
import { j as te, b as re, B as ae, f as K } from "../../factory-BnRIVbT0.js";
import { u as Ce } from "../../use-styles-CB9_o8RJ.js";
import { c as Ye } from "../../create-safe-context-DqDyoPVE.js";
import { S as Ze } from "../../ScrollArea-BABkN_NE.js";
import { F as Se } from "../../Flex-z_b6pdCM.js";
const [Qe, Ke] = Ye(
  "Table component was not found in the tree"
);
var L = { table: "m_b23fa0ef", th: "m_4e7aa4f3", tr: "m_4e7aa4fd", td: "m_4e7aa4ef", tbody: "m_b2404537", thead: "m_b242d975", caption: "m_9e5a3ac7", scrollContainer: "m_a100c15", scrollContainerInner: "m_62259741" };
function et(t, r) {
  if (!r)
    return;
  const l = {};
  return r.columnBorder && t.withColumnBorders && (l["data-with-column-border"] = !0), r.rowBorder && t.withRowBorders && (l["data-with-row-border"] = !0), r.striped && t.striped && (l["data-striped"] = t.striped), r.highlightOnHover && t.highlightOnHover && (l["data-hover"] = !0), r.captionSide && t.captionSide && (l["data-side"] = t.captionSide), r.stickyHeader && t.stickyHeader && (l["data-sticky"] = !0), l;
}
function z(t, r) {
  const l = `Table${t.charAt(0).toUpperCase()}${t.slice(1)}`, i = te((f, p) => {
    const T = re(l, {}, f), u = T, { classNames: y, className: g, style: w, styles: k } = u, b = B(u, ["classNames", "className", "style", "styles"]), m = Ke();
    return /* @__PURE__ */ a(
      ae,
      _(_(_({
        component: t,
        ref: p
      }, et(m, r)), m.getStyles(t, { className: g, classNames: y, style: w, styles: k, props: T })), b)
    );
  });
  return i.displayName = `@mantine/core/${l}`, i.classes = L, i;
}
const ee = z("th", { columnBorder: !0 }), we = z("td", { columnBorder: !0 }), U = z("tr", {
  rowBorder: !0,
  striped: !0,
  highlightOnHover: !0
}), ke = z("thead", { stickyHeader: !0 }), Ne = z("tbody"), xe = z("tfoot"), Pe = z("caption", { captionSide: !0 });
function le({ data: t }) {
  return /* @__PURE__ */ C(Xe, { children: [
    t.caption && /* @__PURE__ */ a(Pe, { children: t.caption }),
    t.head && /* @__PURE__ */ a(ke, { children: /* @__PURE__ */ a(U, { children: t.head.map((r, l) => /* @__PURE__ */ a(ee, { children: r }, l)) }) }),
    t.body && /* @__PURE__ */ a(Ne, { children: t.body.map((r, l) => /* @__PURE__ */ a(U, { children: r.map((i, f) => /* @__PURE__ */ a(we, { children: i }, f)) }, l)) }),
    t.foot && /* @__PURE__ */ a(xe, { children: /* @__PURE__ */ a(U, { children: t.foot.map((r, l) => /* @__PURE__ */ a(ee, { children: r }, l)) }) })
  ] });
}
le.displayName = "@mantine/core/TableDataRenderer";
const tt = {
  type: "scrollarea"
}, rt = ge((t, { minWidth: r, type: l }) => ({
  scrollContainer: {
    "--table-min-width": ve(r),
    "--table-overflow": l === "native" ? "auto" : void 0
  }
})), oe = te((t, r) => {
  const l = re("TableScrollContainer", tt, t), x = l, {
    classNames: i,
    className: f,
    style: p,
    styles: T,
    unstyled: y,
    vars: g,
    children: w,
    minWidth: k,
    type: b
  } = x, m = B(x, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "children",
    "minWidth",
    "type"
  ]), u = Ce({
    name: "TableScrollContainer",
    classes: L,
    props: l,
    className: f,
    style: p,
    classNames: i,
    styles: T,
    unstyled: y,
    vars: g,
    varsResolver: rt,
    rootSelector: "scrollContainer"
  });
  return /* @__PURE__ */ a(
    ae,
    $(_(_($(_({
      component: b === "scrollarea" ? Ze : "div"
    }, b === "scrollarea" ? { offsetScrollbars: "x" } : {}), {
      ref: r
    }), u("scrollContainer")), m), {
      children: /* @__PURE__ */ a("div", $(_({}, u("scrollContainerInner")), { children: w }))
    })
  );
});
oe.classes = L;
oe.displayName = "@mantine/core/TableScrollContainer";
const at = {
  withRowBorders: !0,
  verticalSpacing: 7
}, lt = ge(
  (t, {
    layout: r,
    captionSide: l,
    horizontalSpacing: i,
    verticalSpacing: f,
    borderColor: p,
    stripedColor: T,
    highlightOnHoverColor: y,
    striped: g,
    highlightOnHover: w,
    stickyHeaderOffset: k,
    stickyHeader: b
  }) => ({
    table: {
      "--table-layout": r,
      "--table-caption-side": l,
      "--table-horizontal-spacing": ye(i),
      "--table-vertical-spacing": ye(f),
      "--table-border-color": p ? K(p, t) : void 0,
      "--table-striped-color": g && T ? K(T, t) : void 0,
      "--table-highlight-on-hover-color": w && y ? K(y, t) : void 0,
      "--table-sticky-header-offset": b ? ve(k) : void 0
    }
  })
), s = te((t, r) => {
  const l = re("Table", at, t), W = l, {
    classNames: i,
    className: f,
    style: p,
    styles: T,
    unstyled: y,
    vars: g,
    horizontalSpacing: w,
    verticalSpacing: k,
    captionSide: b,
    stripedColor: m,
    highlightOnHoverColor: u,
    striped: x,
    highlightOnHover: ne,
    withColumnBorders: H,
    withRowBorders: X,
    withTableBorder: I,
    borderColor: R,
    layout: se,
    variant: S,
    data: j,
    children: P,
    stickyHeader: E,
    stickyHeaderOffset: N,
    mod: M,
    tabularNums: V
  } = W, Y = B(W, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "horizontalSpacing",
    "verticalSpacing",
    "captionSide",
    "stripedColor",
    "highlightOnHoverColor",
    "striped",
    "highlightOnHover",
    "withColumnBorders",
    "withRowBorders",
    "withTableBorder",
    "borderColor",
    "layout",
    "variant",
    "data",
    "children",
    "stickyHeader",
    "stickyHeaderOffset",
    "mod",
    "tabularNums"
  ]), D = Ce({
    name: "Table",
    props: l,
    className: f,
    style: p,
    classes: L,
    classNames: i,
    styles: T,
    unstyled: y,
    rootSelector: "table",
    vars: g,
    varsResolver: lt
  });
  return /* @__PURE__ */ a(
    Qe,
    {
      value: {
        getStyles: D,
        stickyHeader: E,
        striped: x === !0 ? "odd" : x || void 0,
        highlightOnHover: ne,
        withColumnBorders: H,
        withRowBorders: X,
        captionSide: b || "bottom"
      },
      children: /* @__PURE__ */ a(
        ae,
        $(_(_({
          component: "table",
          variant: S,
          ref: r,
          mod: [{ "data-with-table-border": I, "data-tabular-nums": V }, M]
        }, D("table")), Y), {
          children: P || !!j && /* @__PURE__ */ a(le, { data: j })
        })
      )
    }
  );
});
s.classes = L;
s.displayName = "@mantine/core/Table";
s.Td = we;
s.Th = ee;
s.Tr = U;
s.Thead = ke;
s.Tbody = Ne;
s.Tfoot = xe;
s.Caption = Pe;
s.ScrollContainer = oe;
s.DataRenderer = le;
const ot = "Table-module__root___5X62v", nt = "Table-module__tableWrapper___voR20", st = "Table-module__table___VzDyA", it = "Table-module__thead___n9aOA", ct = "Table-module__th___tq0gm", dt = "Table-module__td___Js8My", mt = "Table-module__tr___VNlrk", ut = "Table-module__tbody___5LXib", ht = "Table-module__columnSizeXs___3IYGB", _t = "Table-module__columnSizeSm___jwj2y", bt = "Table-module__columnSizeMd___r6fY4", ft = "Table-module__columnSizeLg___wHLLt", pt = "Table-module__columnSizeXl___nejJ-", Tt = "Table-module__columnSizeXxl___wIPEO", yt = "Table-module__sortIcon___573RG", St = "Table-module__tableColumnAdjustment___AuboD", vt = "Table-module__cellContent___1JBZF", gt = "Table-module__fixedColumn___vqaAC", Ct = "Table-module__fixedColumnShadow___-kAhx", wt = "Table-module__activeFilter___-r-fs", kt = "Table-module__filterDropdown___gaD1E", Nt = "Table-module__headerOptions___FovIA", xt = "Table-module__selectColumn___G3JkL", c = {
  root: ot,
  tableWrapper: nt,
  table: st,
  thead: it,
  th: ct,
  td: dt,
  tr: mt,
  tbody: ut,
  columnSizeXs: ht,
  columnSizeSm: _t,
  columnSizeMd: bt,
  columnSizeLg: ft,
  columnSizeXl: pt,
  columnSizeXxl: Tt,
  sortIcon: yt,
  tableColumnAdjustment: St,
  cellContent: vt,
  fixedColumn: gt,
  fixedColumnShadow: Ct,
  activeFilter: wt,
  filterDropdown: kt,
  headerOptions: Nt,
  selectColumn: xt
}, Gt = (ne) => {
  var H = ne, {
    data: t,
    columns: r,
    loading: l,
    emptyMessage: i = "No data available",
    itemsPerPage: f = 10,
    withPagination: p = !1,
    withItemsPerPageSelector: T = !1,
    itemsPerPageOptions: y = [10, 25, 50, 100],
    className: g,
    filterable: w = !1,
    selectable: k = !1,
    selectedRows: b = [],
    idField: m = "id",
    onSelectionChange: u
  } = H, x = B(H, [
    "data",
    "columns",
    "loading",
    "emptyMessage",
    "itemsPerPage",
    "withPagination",
    "withItemsPerPageSelector",
    "itemsPerPageOptions",
    "className",
    "filterable",
    "selectable",
    "selectedRows",
    "idField",
    "onSelectionChange"
  ]);
  const [X, I] = A(1), [R, se] = A(f), [S, j] = A(null), [P, E] = A("asc"), [N, M] = A({}), [V, Y] = A(null), [D, W] = A(!1), h = be(b), J = be(null);
  Ee(() => {
    h.current = b;
  }, [b]);
  const ie = (e) => {
    const n = h.current.includes(e) ? h.current.filter((o) => o !== e) : [...h.current, e];
    h.current = n, u == null || u(n);
  }, ce = () => {
    const e = F.map((d) => d[m]), n = e.every((d) => h.current.includes(d));
    let o;
    if (n)
      o = h.current.filter((d) => !e.includes(d));
    else {
      const d = new Set(h.current);
      e.forEach((v) => d.add(v)), o = Array.from(d);
    }
    h.current = o, u == null || u(o);
  }, Fe = (e) => {
    se(e), I(1);
  };
  Me(() => {
    const e = () => {
      if (J.current) {
        const o = J.current.scrollLeft > 1;
        W(o);
      }
    }, n = J.current;
    return n && (n.addEventListener("scroll", e), e()), () => {
      n && n.removeEventListener("scroll", e);
    };
  }, []);
  const $e = (e) => {
    S === e ? E(P === "asc" ? "desc" : "asc") : (j(e), E("asc"));
  }, Ae = (e, n) => {
    M((o) => $(_({}, o), {
      [e]: n
    })), I(1);
  }, de = (e) => {
    Y(V === e ? null : e);
  }, ze = (e) => {
    M((n) => {
      const o = _({}, n);
      return delete o[e], o;
    });
  }, G = Ve(() => {
    let e = [...t];
    return Object.keys(N).length > 0 && (e = e.filter((n) => Object.entries(N).every(([o, d]) => {
      if (!d) return !0;
      const v = r.find((Oe) => Oe.key === o), O = v != null && v.filterValue ? v.filterValue(n) : n[o];
      return O === void 0 ? !1 : String(O).toLowerCase().includes(d.toLowerCase());
    }))), S && e.sort((n, o) => {
      const d = n[S], v = o[S];
      if (d === v) return 0;
      const O = typeof d == "string" ? d.localeCompare(v) : d - v;
      return P === "asc" ? O : -O;
    }), e;
  }, [t, N, S, P, r]), Ie = Math.ceil(G.length / R), me = (X - 1) * R, Re = me + R, F = p ? G.slice(me, Re) : G, De = ({ content: e }) => /* @__PURE__ */ a(
    "div",
    {
      className: c.cellContent,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "100%"
      },
      children: e
    }
  );
  return /* @__PURE__ */ C(Te, { gap: "sm", className: g, children: [
    /* @__PURE__ */ a("div", { className: c.tableWrapper, ref: J, children: /* @__PURE__ */ C(s, $(_({ classNames: c }, x), { children: [
      /* @__PURE__ */ a(s.Thead, { className: c.thead, children: /* @__PURE__ */ C(s.Tr, { children: [
        k && /* @__PURE__ */ a(
          s.Th,
          {
            className: c.selectColumn,
            onClick: ce,
            style: { cursor: "pointer" },
            children: /* @__PURE__ */ a(
              pe,
              {
                label: "",
                checked: F.length > 0 && F.every((e) => h.current.includes(e[m])),
                indeterminate: F.some((e) => h.current.includes(e[m])) && !F.every((e) => h.current.includes(e[m])),
                onChange: (e) => {
                  e.stopPropagation(), ce();
                },
                onClick: (e) => e.stopPropagation(),
                "aria-label": "Select all rows"
              }
            )
          }
        ),
        r.map((e) => /* @__PURE__ */ a(
          s.Th,
          {
            style: e.width ? { width: e.width } : void 0,
            className: `${e.className || ""} ${e.sortable ? c.sortableHeader : ""} ${e.filterable ? c.filterableHeader : ""} ${e.fixed ? `${c.fixedColumn} ${D ? c.fixedColumnShadow : ""}` : ""} ${e.key in c ? c[e.key] : ""}`,
            children: /* @__PURE__ */ C(Se, { align: "center", gap: "xxs", children: [
              /* @__PURE__ */ a("div", { className: c.headerContent, children: e.header }),
              /* @__PURE__ */ C(Se, { className: c.headerOptions, children: [
                e.sortable && /* @__PURE__ */ a(fe, { label: S === e.key && P === "asc" ? "Sort descending" : "Sort ascending", children: /* @__PURE__ */ a(
                  Z,
                  {
                    variant: "tertiary",
                    onClick: () => $e(e.key),
                    className: S === e.key ? c.activeSort : "",
                    "aria-label": `Sort by ${e.header}`,
                    children: S === e.key && P === "desc" ? /* @__PURE__ */ a(Je, {}) : /* @__PURE__ */ a(Ge, {})
                  }
                ) }),
                e.filterable && w && /* @__PURE__ */ C(
                  Q,
                  {
                    opened: V === e.key,
                    onChange: () => de(e.key),
                    position: "bottom-start",
                    closeOnClickOutside: !0,
                    closeOnEscape: !0,
                    children: [
                      /* @__PURE__ */ a(Q.Target, { children: /* @__PURE__ */ a("div", { className: N[e.key] ? c.activeFilter : "", children: /* @__PURE__ */ a(fe, { label: `Filter ${e.header}`, children: /* @__PURE__ */ a(
                        Z,
                        {
                          variant: "tertiary",
                          onClick: () => de(e.key),
                          "aria-label": `Filter ${e.header}`,
                          children: /* @__PURE__ */ a(qe, { filled: !!N[e.key] })
                        }
                      ) }) }) }),
                      /* @__PURE__ */ a(Q.Dropdown, { className: c.filterDropdown, children: /* @__PURE__ */ C(Te, { gap: "xs", children: [
                        /* @__PURE__ */ a(
                          We,
                          {
                            w: "100%",
                            label: "Filter",
                            value: N[e.key] || "",
                            onChange: (n) => Ae(e.key, n.target.value)
                          }
                        ),
                        N[e.key] && /* @__PURE__ */ a(
                          Z,
                          {
                            variant: "tertiary",
                            onClick: () => ze(e.key),
                            "aria-label": "Clear filter",
                            leftSection: /* @__PURE__ */ a(Ue, {}),
                            children: "Remove filter"
                          }
                        )
                      ] }) })
                    ]
                  }
                )
              ] })
            ] })
          },
          e.key
        ))
      ] }) }),
      /* @__PURE__ */ a(s.Tbody, { children: l ? /* @__PURE__ */ a(s.Tr, { children: /* @__PURE__ */ a(s.Td, { colSpan: r.length, align: "center", children: "Loading..." }) }) : F.length === 0 ? /* @__PURE__ */ a(s.Tr, { children: /* @__PURE__ */ a(s.Td, { colSpan: r.length, align: "center", children: i }) }) : F.map((e, n) => /* @__PURE__ */ C(s.Tr, { children: [
        k && /* @__PURE__ */ a(
          s.Td,
          {
            className: c.selectColumn,
            onClick: () => ie(e[m]),
            style: { cursor: "pointer" },
            children: /* @__PURE__ */ a(
              pe,
              {
                label: "",
                checked: h.current.includes(e[m]),
                onChange: (o) => {
                  o.stopPropagation(), ie(e[m]);
                },
                onClick: (o) => o.stopPropagation(),
                "aria-label": `Select row ${n + 1}`
              }
            )
          }
        ),
        r.map((o, d) => /* @__PURE__ */ a(
          s.Td,
          {
            "data-cell-index": d,
            className: `${o.className || ""} ${o.fixed ? `${c.fixedColumn} ${D ? c.fixedColumnShadow : ""}` : ""}`,
            children: o.render ? o.render(e) : /* @__PURE__ */ a(De, { content: String(e[o.key]) })
          },
          `${n}-${o.key}`
        ))
      ] }, n)) })
    ] })) }),
    p && /* @__PURE__ */ a(
      je,
      {
        total: Ie,
        value: X,
        onChange: I,
        withItemsPerPage: T,
        totalItems: G.length,
        itemsPerPage: R,
        itemsPerPageOptions: y,
        onItemsPerPageChange: Fe
      }
    )
  ] });
};
export {
  Gt as Table
};
